import { apiClient } from './axios';
import { ISupplier } from './suppliers';

export enum GiftStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface IGift {
  id: number;
  name: string;
  description: string;
  remainingQuantity: number;
  unitPrice: number;
  supplier: ISupplier;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  status: GiftStatus;
}

export interface GiftFormData {
  name: string;
  description: string;
  remainingQuantity: number;
  unitPrice: number;
  supplierId: number;
}
export const getGifts = async (id: string, name: string): Promise<IGift[]> => {
  const response = await apiClient.get<IGift[]>('gifts', {
    params: {
      supplierId: id,
      name,
    },
  });
  return response.data;
};

export const createGift = async (gift: GiftFormData): Promise<IGift> => {
  const response = await apiClient.post<IGift>('gifts', gift);
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

export const updateGift = async (
  id: string,
  gift: GiftFormData
): Promise<IGift> => {
  const response = await apiClient.patch<IGift>(`gifts/${id}`, gift);
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

export const deleteGift = async (id: string) => {
  const response = await apiClient.delete(`gifts/${id}`);
  if (!response.success && response?.error) {
    throw new Error(response.message);
  }
  return response.data;
};

export const changeStatusGift = async (id: number, status: GiftStatus) => {
  const response = await apiClient.patch(`gifts/${id}/status`, {
    status,
  });
  if (!response.success && response?.error) {
    throw new Error(response.message);
  }
  return response.data;
};
